import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  RESUME_ERROR,
  RESUME_START,
  RESUME_SUCCESS,
  RESUME_CANCEL,
  RESUME_LOADING,
} from '@src/app/accounts/resume/actions';
import { OMS_LOOKUP_SUCCESS } from '@src/app/login/oms/actions';

export interface ResumeSavedResultItem {
  prodIdAlias: string;
  accountNumber: string;
  productName: string;
  directResume: boolean;
  planCode: string;
  history: any;
}

export interface ResumeSavedResult {
  success?: boolean;
  message?: string;
  payload: ResumeSavedResultItem[];
}

export type State = {
  readonly loading: boolean;
  resumeSavedResult: ResumeSavedResult | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case RESUME_ERROR:
      // case RESUME_SUCCESS:
      case OMS_LOOKUP_SUCCESS:
      case RESUME_CANCEL:
        return false;
      case RESUME_START:
      case RESUME_LOADING:
        return true;
      default:
        return state;
    }
  },

  resumeSavedResult: (state = null, action) => {
    switch (action.type) {
      case RESUME_SUCCESS:
      case RESUME_ERROR:
        return action.payload;
      case RESUME_CANCEL:
      case RESUME_START:
        return null;
      default:
        return state;
    }
  },
});
